
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9 .833L8.143 0H3.857L3 .833H0V2.5h12V.833H9zm-8.143 12.5C.857 14.25 1.63 15 2.571 15H9.43c.942 0 1.714-.75 1.714-1.667v-10H.857v10zM2.571 5v8.333H9.43V5H2.57z","fill":"#585858"}})])
          )
        }
      }
    